import { makeSelector } from "../../../testing/index.js";
import { InputSelectors } from "../Input/input.selectors.js";
const TestingAttrs = {
  clearButton: "data-clear-button",
  applyButton: "data-apply-button",
  searchInput: "data-search-input"
};
const DropdownContentSelectors = {
  clearButton: makeSelector("Clear button", TestingAttrs.clearButton),
  applyButton: makeSelector("Apply button", TestingAttrs.applyButton),
  searchInput: makeSelector("Search input", TestingAttrs.searchInput, InputSelectors.input)
};
export {
  DropdownContentSelectors,
  TestingAttrs
};
